const NoDataView = (props: { text: string }) => (
  <p className="text-center mt-auto mb-auto">
    {props.text ? props.text : 'No reports in selected time period'}
  </p>
);
export default NoDataView;
